let globalsInitialized = false;
let cssMarkerInstalled = false;

export const ensureGlobals = () => {
  if (globalsInitialized) return;
  globalsInitialized = true;
  const g = globalThis as Record<string, unknown>;
  if (g.global === undefined) g.global = globalThis;
  if (globalThis.process === undefined) {
    (globalThis as Record<string, unknown>).process = { env: {} };
  }
};

export const ensureCssMarker = () => {
  if (cssMarkerInstalled) return;
  cssMarkerInstalled = true;
  const id = '__next_css__DO_NOT_USE__';
  if (!document.getElementById(id)) {
    const marker = document.createElement('noscript');
    marker.id = id;
    document.head.appendChild(marker);
  }
};

const registeredOrigins = new Set<string>();
let sharedObserver: MutationObserver | null = null;

const rewriteImage = (img: HTMLImageElement) => {
  const src = img.getAttribute('src') ?? '';
  if (!src.startsWith('/_next/')) return;

  const origins = Array.from(registeredOrigins).reverse();
  if (origins.length > 0) {
    img.src = `${origins[0]}${src}`;
  }
};

const handleMutations = (mutations: MutationRecord[]) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node instanceof HTMLImageElement) {
        rewriteImage(node);
      }
      if (node instanceof HTMLElement) {
        for (const img of node.querySelectorAll<HTMLImageElement>(
          'img[src^="/_next/"]',
        )) {
          rewriteImage(img);
        }
      }
    }
  }
};

export const watchImageSources = (remoteOrigin: string) => {
  if (registeredOrigins.has(remoteOrigin)) return;
  registeredOrigins.add(remoteOrigin);

  if (!sharedObserver) {
    sharedObserver = new MutationObserver(handleMutations);
    sharedObserver.observe(document.body, { childList: true, subtree: true });
  }

  for (const img of document.querySelectorAll<HTMLImageElement>(
    'img[src^="/_next/"]',
  )) {
    rewriteImage(img);
  }
};

export const unwatchImageSources = (remoteOrigin: string) => {
  registeredOrigins.delete(remoteOrigin);

  if (registeredOrigins.size === 0 && sharedObserver) {
    sharedObserver.disconnect();
    sharedObserver = null;
  }
};
